import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'

import enApp from './locales/en/app.json'
import deApp from './locales/de/app.json'
import enSettings from './locales/en/settings.json'
import deSettings from './locales/de/settings.json'
import enTransactions from './locales/en/transactions.json'
import deTransactions from './locales/de/transactions.json'
import enGmailSearch from './locales/en/gmail-search.json'
import deGmailSearch from './locales/de/gmail-search.json'
import enInvoicesOverview from './locales/en/invoices-overview.json'
import deInvoicesOverview from './locales/de/invoices-overview.json'
import enOnboarding from './locales/en/onboarding.json'
import deOnboarding from './locales/de/onboarding.json'
import enImportProgressBar from './locales/en/import-progress-bar.json'
import deImportProgressBar from './locales/de/import-progress-bar.json'
import enSidebarChat from './locales/en/sidebar-chat.json'
import deSidebarChat from './locales/de/sidebar-chat.json'
import enSplitTabs from './locales/en/split-tabs.json'
import deSplitTabs from './locales/de/split-tabs.json'
import enMatchSearch from './locales/en/match-search.json'
import deMatchSearch from './locales/de/match-search.json'

export const initI18n = async () => {
    await i18n
        .use(LanguageDetector)
        .use(initReactI18next)
        .init({
            resources: {
                en: {
                    app: enApp,
                    settings: enSettings,
                    transactions: enTransactions,
                    'gmail-search': enGmailSearch,
                    'invoices-overview': enInvoicesOverview,
                    onboarding: enOnboarding,
                    'import-progress-bar': enImportProgressBar,
                    'sidebar-chat': enSidebarChat,
                    'split-tabs': enSplitTabs,
                    'match-search': enMatchSearch,
                },
                de: {
                    app: deApp,
                    settings: deSettings,
                    transactions: deTransactions,
                    'gmail-search': deGmailSearch,
                    'invoices-overview': deInvoicesOverview,
                    onboarding: deOnboarding,
                    'import-progress-bar': deImportProgressBar,
                    'sidebar-chat': deSidebarChat,
                    'split-tabs': deSplitTabs,
                    'match-search': deMatchSearch,
                },
            },
            fallbackLng: 'en',
            defaultNS: 'app',
            ns: [
                'app',
                'settings',
                'transactions',
                'gmail-search',
                'invoices-overview',
                'onboarding',
                'import-progress-bar',
                'sidebar-chat',
                'split-tabs',
                'match-search',
            ],
            interpolation: {
                escapeValue: false,
            },
            detection: {
                order: ['localStorage', 'navigator'],
                caches: ['localStorage'],
                lookupLocalStorage: 'i18nextLng',
            },
        })
}

export { i18n }
